module.exports = __webpack_public_path__ + "img/small.93abcd3b.jpg";